var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckBase = function SvgIconCheckBase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.033 6.572c.496.608.46 1.504-.106 2.071l-8.764 8.763a1.546 1.546 0 0 1-2.189 0l-4.52-4.52a1.548 1.548 0 1 1 2.189-2.19l3.426 3.426 7.668-7.668a1.546 1.546 0 0 1 2.072-.106l.118.106.106.118z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgIconCheckBase;